import React from 'react';

const HouseFillSvg = (props) => (
    <svg
        className="house-fill_svg__eds-icon--house-fill__svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="house-fill_svg__eds-icon--house-fill__base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5.2l-8 6.3V22h6v-6h4v6h6V11.5l-8-6.3z"
        />
        <path
            className="house-fill_svg__eds-icon--house-fill__roof"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2L2 10.2l.6.8L12 3.5l9.3 7.5.7-.8"
        />
    </svg>
);

HouseFillSvg.displayName = 'HouseFillSvg';
export default HouseFillSvg;
